// extracted by mini-css-extract-plugin
export var createdDate = "_fd-1";
export var divider = "_fd-2";
export var headerDivider = "_fd-3";
export var messagesCard = "_fd-0";
export var messagesContainer = "_fd-7";
export var messagesContainerWrapper = "_fd-4";
export var pointerCapturingButtonBoxes = "_fd-a";
export var showLeftPanelButton = "_fd-9";
export var showMoreButton = "_fd-c";
export var showMoreButtonContainer = "_fd-b";
export var summaryTitle = "_fd-6";
export var systemMessageCardWrapper = "_fd-d";
export var topButtons = "_fd-8";
export var withPadding = "_fd-5";